export default [{
  name: 'none',
  value: 0,
  unit: 'px'
}, {
  name: 'small',
  value: 4,
  unit: 'px'
}, {
  name: 'medium',
  value: 10,
  unit: 'px'
}, {
  name: 'large',
  value: 100,
  unit: 'px'
}];